<template>
  <div class="our-values-card">
    <div class="row no-gutters justify-content-md-between justify-content-lg-center">
      <div class="col-10 offset-1 col-md-5 offset-md-0 col-lg-9">
        <h3 class="our-values-card__title push-v--tablet--small">{{ title }}</h3>
        <div v-if="body" class="our-values-card__body text--x-small text--faux push-v--desktop--medium" v-html="body" />
      </div>
      <div class="col-10 offset-1 col-md-5 offset-md-0 col-lg-7">
        <div class="our-values-card__image-wrapper push-v--mobile--medium push-v--tablet--medium">
          <our-values-image
              :shape="shape"
              :image="image"
              :class="`our-values-card__image our-values-card__image--${shape}`"
          />
          <div class="our-values-card__button-container">
            <call-to-action-button :external-link="externalLink" :call-to-action-link-text="callToActionText" :call-to-action-link="link" button-class="our-values-card__button" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import OurValuesImage from '~/components/elements/OurValuesImage.vue';
import CallToActionButton from '~/components/components/CallToActionButton';

export default {
  components: {
    OurValuesImage,
    CallToActionButton,
  },
  props: {
    shape: { type: String, required: true },
    title: { type: String, required: true },
    body: { type: String, default: '' },
    image: {
      type: Object,
      required: true,
      default() {
        return {
          url: { type: String, required: true },
          description: { type: String, required: true },
        };
      },
    },
    callToActionText: { type: String, default: '', required: false },
    externalLink: { type: String, default: '', required: false },
    link: {
      type: Object,
      default() {
        return {
          slug: '',
        };
      },
    },
  },
};
</script>

<style lang="scss">
@import '~/assets/scss/atomic/components/_our-values-card.scss';
</style>
